var map = {
	"./de/translation.json": 2168,
	"./en/translation.json": 1996,
	"./es/translation.json": 4107,
	"./fr/translation.json": 5387,
	"./it/translation.json": 2755,
	"./nl/translation.json": 8561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3852;